export default __webpack_public_path__ + "static/media/digital_platforms_m.24f70dcc.jpg";